<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div
  class="tab"
  [ngClass]="{
    'variant-primary': variant === 'primary',
    'variant-secondary': variant === 'secondary',
    'variant-tertiary': variant === 'tertiary',
    'style-underline': mode === 'underline',
    'style-text': mode === 'text',
    disabled: disabled,
    selected: selected,
    active: !disabled && !selected,
  }"
  [attr.aria-selected]="selected"
  (click)="onTabClick()"
  >
  <div class="tab-content">
    @if (icon) {
      <hyperkit-icon color="inherit" size="small" [icon]="icon"></hyperkit-icon>
    }
    <hyperkit-typography
      [variant]="typographyVariant"
      color="inherit"
      class="text"
      >
      {{ text }}
    </hyperkit-typography>
    @if (variant !== 'tertiary' && count !== null) {
      <div class="count">
        <hyperkit-typography variant="emphasized" size="sm" color="inherit">
          {{ count }}
        </hyperkit-typography>
      </div>
    }
  </div>

  <!-- Underline -->
  @if (variant !== 'tertiary') {
    <div class="underline-wrapper">
      @if (mode === 'underline' && selected) {
        <div class="underline"></div>
      }
    </div>
  }
</div>

<!-- Capturing the content for uncontrolled tabs -->
<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
